import { render, staticRenderFns } from "./SttrPD.vue?vue&type=template&id=edfa1996"
import script from "./SttrPD.vue?vue&type=script&lang=js"
export * from "./SttrPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports